import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { GetTasksFilterDto } from "../model/task/dto/GetTasksFilterDto";
import { useAppSelector } from "../redux/store";
import { userSliceSelectors } from "../redux/user/user.selector";

type GlobalFormProvidersProps = {
  children: React.ReactNode;
};

export const GlobalFormProviders: React.FC<GlobalFormProvidersProps> = ({
  children,
}) => {
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  const tasksFilterFormMethods = useForm<GetTasksFilterDto>({
    defaultValues: {
      keyword: "",
      reminder: undefined,
      kind: undefined,
      userId,
      done: null,
    },
  });

  return <FormProvider {...tasksFilterFormMethods}>{children}</FormProvider>;
};
